const deviceType = IsPC()?'pc':'mobile'
const host = process.env.NODE_ENV == 'development' ? 'http://172.30.1.101:5000/' : 'https://api-m3guo.17m3.com/';
const webUrl = process.env.NODE_ENV == 'development' ? 'http://192.168.217.171:2887/' : 'https://www.m3guo.com/activity/202201/invite-a13488d1/';
const domain = deviceType == 'pc' ? webUrl + 'pc.html' : webUrl + 'm.html';

const getQueryVariable = function (variable) {
    var query = window.location.search.substring(1) || window.location.hash.substring(1);
    var vars = query.split("&");

    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
        return pair[1];
        }
    }
    return '';
}

let search_code = getQueryVariable('code') ? ('?code=' + getQueryVariable('code')) : '';
let add = getQueryVariable('code') ? '&' : '?';
let search_key = getQueryVariable('key') ? (add + 'key=' + getQueryVariable('key')) : '';

const ajax_url_map = {
    login : host + 'api/login/authorize?callbackurl=' + encodeURIComponent(domain),
    logout : '',
    free : host + 'api/Login/KouDai',
    logininfo : host + 'api/user/getLoginInfo',
    userinfo : host + 'api/User/GetUserInfo',
    queryplayer : host + 'api/user/GetNickName',
    bind : host + 'api/user/bind',
    gift : host + 'api/Gift/RwOption',//自选奖励
    backer : host + 'api/User/CheckBacker',//判断当前用户是否回归用户
    friend_list : host + 'api/User/GetFriendList',//好友列表
    task_info : host + 'api/UserTask/TaskList',//我的任务列表 没有受邀或邀请，对应列表可能不存在
    task_detail : host + 'api/Activte/GetActiveTaskList',//任务奖励明细
    apply_gift : host + 'api/Gift/RwTaskType',//一键领取邀请 每日达成120活跃任务次数 军团出征/竞技完成次数
    apply_task_invite : host + 'api/Gift/RwTaskNo',//并肩作战*123
    player_check : host + 'api/User/CheckBacker',//判断当前用户是否回归用户
    apply_return_gift : host + 'api/Gift/RwOption',//回归登录选奖
    draw : host + 'api/Gift/Draw',//抽奖
    draw_record : host + 'api/Gift/GetUserGiftList',//用户获得奖励列表
    drwa_list : host + 'api/Gift/List',//活动奖励列表 part：100转盘
    lucky_list : host + 'api/Gift/GetDrawList',//抽奖榜单
    short_url : host + 'api/Share/getInviteCode',//短链接
    invite_info : host + 'api/share/getInviteNick',//邀请信息查询
    invite_apply : host + 'api/User/BindCode',//相应邀请
    reflash : host + 'api/UserTask/Refresh',//召回任务刷新
    mplat : host + 'api/login/mplat',//梦平台免登录
}

const issn = '220110';

const bodyScroll = function(event) {
    event.preventDefault();
}

const cleanArray = function (actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

const param =  function (json) {
  if (!json) return ''
  return cleanArray(Object.keys(json).map(key => {
    if (json[key] === undefined)
      return ''
    return encodeURIComponent(key) +
    '=' + encodeURIComponent(json[key])
  })).join('&')
}

function IsPC() {
  var userAgentInfo = navigator.userAgent;
  var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
  var flag = true;
  for (var v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
      }
  }
  return flag;
}

export default {
    bodyScroll,
    ajax_url_map,
    getQueryVariable,
    domain,
    param,
    issn,
    deviceType,
}


// WEBPACK FOOTER //
// ./src/js/global.js